import {
  type NamedPathLookupAdvancedOptions,
  factoryPathLookupAdvancedOptions,
} from '@ipfabric/utils';
import { getPathLookupAdvancedOptionsPresetIdFromLocalStorage } from 'components/Graph/GraphSidePanel/GraphPathlookup/PathLookupLocalStorage';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export const loadAdvancedOptions: GraphCommandFactory =
  (cmdContext) => async () => {
    try {
      const advancedOptions = await cmdContext.api.request<
        NamedPathLookupAdvancedOptions[]
      >({
        url: '/graphs/path-lookup/advanced-options',
        method: 'GET',
      });

      const savedPresetId =
        getPathLookupAdvancedOptionsPresetIdFromLocalStorage();
      const foundPreset = advancedOptions.find(
        ({ id }) => id === savedPresetId,
      );

      cmdContext.updateState((draft) => {
        draft.pathlookup.advancedOptions = advancedOptions?.length
          ? advancedOptions
          : factoryPathLookupAdvancedOptions;
        if (foundPreset) {
          draft.pathlookup.selectedAdvancedOptions = foundPreset;
        }
      });
    } catch (e) {
      cmdContext.updateState((draft) => {
        draft.loading = 'ERROR';
      });
      cmdContext.logError(e, 'GRAPH');
    }
  };
